'use client';

import { FinancialIndependenceResult } from './types';
import { FinancialIndependenceTranslations } from './types';

interface ResultsDisplayProps {
  result: FinancialIndependenceResult;
  translations: FinancialIndependenceTranslations;
  currency: string;
}

export default function ResultsDisplay({ result, translations, currency }: ResultsDisplayProps) {
  return (
    <div className="space-y-8">
      <h3 className="text-sm font-semibold text-gray-800 mb-1">{translations.resultLabel}</h3>
      {/* Target Amount Result */}
      <div className="p-4 bg-green-50 rounded-lg border border-green-100">
        <div className="text-sm text-gray-600">{translations.targetAmountLabel}</div>
        <div className="text-3xl font-bold text-green-900">
          {result.targetAmount.toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
        </div>
      </div>

      {/* Years to Independence Result */}
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.yearsToIndependenceLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {result.yearsToIndependence === -1 ? '-' : `${result.yearsToIndependence} ${translations.yearsSuffix}`}
        </div>
      </div>
      
      {/* Additional Information Box */}
      <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
        <p className="text-sm font-medium text-gray-700 mb-3">{translations.detailedInfoTitle}</p>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <p className="text-gray-600">{translations.monthlyDividendIncomeLabel}:</p>
            <p className="font-semibold text-gray-800">
              {Math.round(result.monthlyDividendIncome).toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
            </p>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Totala insättningar:</span>
            <span className="font-semibold text-gray-800">
              {Math.round(result.totalSavings).toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total avkastning:</span>
            <span className="font-semibold text-gray-800">
              {Math.round(result.totalReturn).toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Slutvärde:</span>
            <span className="font-semibold text-gray-800">
              {Math.round(result.finalAmount).toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
            </span>
          </div>
        </div>
      </div>
      
      <p className="text-xs text-gray-500">{translations.formulaNote}</p>
    </div>
  );
}
